
import SelectField from "../SelectField";
import React, {memo, useEffect} from "react";

// Custom dropdown editor
export const CustomDropdownEditor = memo((props: any) => {
    return (
            <SelectField
                clearable={props.clearable || false}
                style={{width:props.width}}
                multi={props.multi}
                dataSource={props.datasource}
                value={props.value}
                rendererKey={(values) => props.renderer(values, props.t)}
                onChange={props.onChange}
            />
    );
});



// WEBPACK FOOTER //
// ./src/components/kuma/SelectEdit.tsx